// TODO rename UserEventProperties, UserEvents to something easy to understand
const UserEventProperties = {
  DOWN: "down",
  MOVE: "move",
  UP: "up",
  OVER: "over",
  OUT: "out",
  LEAVE: "leave",
  SCROLL: "scroll",
  SCROLL_SMOOTH: "scroll-smooth",
  CLICK_SPOT: "clickSpot",
  DRAG: "drag",
  DROP: "drop",
  INTERSECTION: "intersection",
};

const UserEvents = {
  DOWN: "pointerdown",
  MOVE: "pointermove",
  UP: "pointerup",
  OVER: "pointerover",
  OUT: "pointerout",
  LEAVE: "pointerleave",
  SCROLL: "scroll",
  CLICK_SPOT: "clickSpot",
  DRAG: "drag",
  DRAG_START: "dragstart",
  DRAG_MOVE: "dragmove",
  DRAG_END: "dragend",
  DROP: "drop",
};

export { UserEventProperties, UserEvents };
